import { render, staticRenderFns } from "./Qualidade2.vue?vue&type=template&id=40d602e8&scoped=true&"
import script from "./Qualidade2.vue?vue&type=script&lang=js&"
export * from "./Qualidade2.vue?vue&type=script&lang=js&"
import style0 from "./Qualidade2.vue?vue&type=style&index=0&id=40d602e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d602e8",
  null
  
)

export default component.exports